/*========================================================================
 * $Id: personalization.js 75056 2013-09-17 15:51:51Z daniel.eppensteiner $
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2017
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

define([
    "api/v2/sourceinfo", 
    "service/factory",
    "service/stub",
    "model/readonlytree",
    "backbone",
    "underscore"
  ], function(
    SourceInfo, 
    ServiceFactory,
    Stub,
    ReadOnlyTreeModel,
    Backbone,
    _
  ) {

  var Personalization = {};

  var PersonalizationServiceStub = Personalization.PersonalizationServiceStub = Stub.extend({
    path: "personalization"
  });

  var PersonalizationOutputModel = Personalization.PersonalizationOutputModel = Backbone.Model.extend({
  });

  var PersonalizationServiceFactory = Personalization.ServiceFactory = function() {}

   _.extend(PersonalizationServiceFactory.prototype, ServiceFactory.prototype, {
    createModel:  function(channel, options) {
      options = options || {};
      options.channel = options.channel || channel;
      options.serviceStub = options.serviceStub || new PersonalizationServiceStub();
      var model = new PersonalizationOutputModel({}, options);
      return model;
    },
    createStub: function() { return new PersonalizationServiceStub(); }
  });

  return Personalization;
})
